(function () {
  var PICKUP_WINDOW_START = "09:00";
  var PICKUP_WINDOW_END = "17:00";
  var PICKUP_MIN_WINDOW_MINUTES = 120;

  function base64ToBlob(base64, mimeType) {
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: mimeType || "application/octet-stream" });
  }

  function showStatus(element, type, message) {
    if (!element) {
      return;
    }

    element.hidden = false;
    element.classList.remove("success", "error");
    element.classList.add(type);
    element.textContent = trimTrailingPeriod(message);
  }

  function hideStatus(element) {
    if (!element) {
      return;
    }

    element.hidden = true;
    element.textContent = "";
    element.classList.remove("success", "error");
  }

  function revealSection(element) {
    if (!element) {
      return;
    }

    window.requestAnimationFrame(function () {
      if (typeof element.focus === "function") {
        try {
          element.focus({ preventScroll: true });
        } catch (_error) {
          element.focus();
        }
      }

      if (typeof element.scrollIntoView === "function") {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  }

  function setButtonBusy(button, isBusy) {
    if (!button) {
      return;
    }

    var label = button.querySelector("span");

    if (label && button.dataset.busyLabel) {
      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = label.textContent;
      }

      label.textContent = isBusy
        ? button.dataset.busyLabel
        : (button.dataset.defaultLabel || label.textContent);
    }

    button.disabled = isBusy;
    button.setAttribute("aria-busy", String(isBusy));
  }

  function normalizePayload(formData) {
    return {
      officeName: formData.get("officeName") || "",
      contactName: formData.get("contactName") || "",
      email: formData.get("email") || "",
      phone: formData.get("phone") || "",
      senderAddress1: formData.get("senderAddress1") || "",
      senderCity: formData.get("senderCity") || "",
      senderState: formData.get("senderState") || "",
      senderPostalCode: formData.get("senderPostalCode") || "",
      packageCount: formData.get("packageCount") || "1",
      website: formData.get("website") || ""
    };
  }

  function normalizePickupPayload(formData) {
    return {
      officeName: formData.get("officeName") || "",
      contactName: formData.get("contactName") || "",
      email: formData.get("email") || "",
      phone: formData.get("phone") || "",
      senderAddress1: formData.get("senderAddress1") || "",
      senderCity: formData.get("senderCity") || "",
      senderState: formData.get("senderState") || "",
      senderPostalCode: formData.get("senderPostalCode") || "",
      pickupDate: formData.get("pickupDate") || "",
      readyTime: formData.get("readyTime") || "",
      closeTime: formData.get("closeTime") || "",
      pickupPoint: formData.get("pickupPoint") || "",
      room: formData.get("room") || "",
      floor: formData.get("floor") || "",
      specialInstructions: formData.get("specialInstructions") || "",
      trackingNumber: formData.get("trackingNumber") || "",
      labelRequestId: formData.get("labelRequestId") || "",
      packageCount: formData.get("packageCount") || "1",
      website: formData.get("website") || ""
    };
  }

  async function parseResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return {};
    }
  }

  function trimTrailingPeriod(message) {
    if (typeof message !== "string") {
      return message;
    }

    return message.replace(/\.+$/, "");
  }

  function withRequestId(message, requestId) {
    return message;
  }

  function deriveEndpoint(fallbackEndpoint, explicitEndpoint, fromPath, toPath) {
    if (explicitEndpoint) {
      return explicitEndpoint;
    }

    if (!fallbackEndpoint) {
      return "";
    }

    return fallbackEndpoint.replace(new RegExp(fromPath + "\\/?$"), toPath);
  }

  function derivePickupEndpoint(labelEndpoint, explicitPickupEndpoint) {
    return deriveEndpoint(labelEndpoint, explicitPickupEndpoint, "create-label", "create-pickup");
  }

  function deriveCancelPickupEndpoint(pickupEndpoint, explicitCancelPickupEndpoint) {
    return deriveEndpoint(pickupEndpoint, explicitCancelPickupEndpoint, "create-pickup", "cancel-pickup");
  }

  function getLocalDateString() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    return year + "-" + month + "-" + day;
  }

  function parseTimeToMinutes(value) {
    if (!/^([01]\d|2[0-3]):([0-5]\d)$/.test(value || "")) {
      return null;
    }

    var parts = value.split(":");
    return (Number(parts[0]) * 60) + Number(parts[1]);
  }

  function isWeekendDateString(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) {
      return false;
    }

    var parts = value.split("-").map(Number);
    var date = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    var day = date.getDay();

    return day === 0 || day === 6;
  }

  function getNextBusinessDateString(startValue) {
    var baseDate;

    if (/^\d{4}-\d{2}-\d{2}$/.test(startValue || "")) {
      var parts = startValue.split("-").map(Number);
      baseDate = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    } else {
      baseDate = new Date();
      baseDate.setHours(12, 0, 0, 0);
    }

    while (baseDate.getDay() === 0 || baseDate.getDay() === 6) {
      baseDate.setDate(baseDate.getDate() + 1);
    }

    var year = baseDate.getFullYear();
    var month = String(baseDate.getMonth() + 1).padStart(2, "0");
    var day = String(baseDate.getDate()).padStart(2, "0");

    return year + "-" + month + "-" + day;
  }

  function formatDurationLabel(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (hours > 0 && minutes === 0) {
      return hours + "-hour";
    }

    if (hours > 0) {
      return hours + "h " + minutes + "m";
    }

    return minutes + "-minute";
  }

  function getPickupGuardrailError(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return null;
    }

    var dateField = pickupForm.elements.namedItem("pickupDate");
    var readyField = pickupForm.elements.namedItem("readyTime");
    var closeField = pickupForm.elements.namedItem("closeTime");
    var today = getLocalDateString();
    var startMinutes = parseTimeToMinutes(PICKUP_WINDOW_START);
    var endMinutes = parseTimeToMinutes(PICKUP_WINDOW_END);
    var readyMinutes = parseTimeToMinutes(readyField && readyField.value);
    var closeMinutes = parseTimeToMinutes(closeField && closeField.value);

    if (dateField && dateField.value && dateField.value < today) {
      return {
        field: dateField,
        message: "Pickup date cannot be in the past."
      };
    }

    if (dateField && dateField.value && isWeekendDateString(dateField.value)) {
      return {
        field: dateField,
        message: "Pickups are available Monday through Friday only."
      };
    }

    if (readyField && Number.isFinite(readyMinutes) && (readyMinutes < startMinutes || readyMinutes >= endMinutes)) {
      return {
        field: readyField,
        message: "Earliest pickup time must be between 9:00 AM and 5:00 PM."
      };
    }

    if (closeField && Number.isFinite(closeMinutes) && (closeMinutes <= startMinutes || closeMinutes > endMinutes)) {
      return {
        field: closeField,
        message: "Latest pickup time must be between 9:00 AM and 5:00 PM."
      };
    }

    if (Number.isFinite(readyMinutes) && Number.isFinite(closeMinutes) && (closeMinutes - readyMinutes) < PICKUP_MIN_WINDOW_MINUTES) {
      return {
        field: closeField,
        message: "Please allow at least a " + formatDurationLabel(PICKUP_MIN_WINDOW_MINUTES) + " pickup window."
      };
    }

    return null;
  }

  function applyPickupFieldConstraints(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return;
    }

    var dateField = pickupForm.elements.namedItem("pickupDate");
    var readyField = pickupForm.elements.namedItem("readyTime");
    var closeField = pickupForm.elements.namedItem("closeTime");
    var today = getLocalDateString();
    var nextBusinessDay = getNextBusinessDateString(today);

    if (dateField) {
      dateField.min = today;

      if (!dateField.value || dateField.value < today || isWeekendDateString(dateField.value)) {
        dateField.value = nextBusinessDay;
      }
    }

    if (readyField) {
      readyField.min = PICKUP_WINDOW_START;
      readyField.max = PICKUP_WINDOW_END;
      readyField.step = 900;

      if (!readyField.value) {
        readyField.value = PICKUP_WINDOW_START;
      }
    }

    if (closeField) {
      closeField.min = PICKUP_WINDOW_START;
      closeField.max = PICKUP_WINDOW_END;
      closeField.step = 900;

      if (!closeField.value) {
        closeField.value = PICKUP_WINDOW_END;
      }
    }
  }

  function syncPickupFieldValidity(pickupForm) {
    if (!pickupForm || !pickupForm.elements) {
      return null;
    }

    ["pickupDate", "readyTime", "closeTime"].forEach(function (fieldName) {
      var field = pickupForm.elements.namedItem(fieldName);

      if (field && typeof field.setCustomValidity === "function") {
        field.setCustomValidity("");
      }
    });

    var guardrailError = getPickupGuardrailError(pickupForm);

    if (guardrailError && guardrailError.field && typeof guardrailError.field.setCustomValidity === "function") {
      guardrailError.field.setCustomValidity(guardrailError.message);
    }

    return guardrailError;
  }

  function setFieldValue(form, name, value) {
    if (!form || !form.elements) {
      return;
    }

    const field = form.elements.namedItem(name);

    if (!field) {
      return;
    }

    field.value = value;
  }

  function revokeLabelUrls(labelUrls) {
    labelUrls.forEach(function (entry) {
      if (entry && entry.url) {
        window.URL.revokeObjectURL(entry.url);
      }
    });
  }

  function renderTrackingList(listElement, summaryElement, trackingNumbers) {
    if (!listElement || !summaryElement) {
      return;
    }

    listElement.innerHTML = "";

    trackingNumbers.forEach(function (trackingNumber) {
      const item = document.createElement("li");
      item.textContent = trackingNumber;
      listElement.appendChild(item);
    });

    summaryElement.hidden = trackingNumbers.length <= 1;
  }

  function renderLabelList(listElement, labels, onPrint, options) {
    if (!listElement) {
      return;
    }

    const settings = options || {};
    const summaryCount = settings.summaryCount || labels.length;
    const combinedDocument = Boolean(settings.combinedDocument);
    listElement.innerHTML = "";

    labels.forEach(function (entry) {
      const card = document.createElement("article");
      card.className = "ups-label-result__label-item";

      const title = document.createElement("h3");
      title.className = "ups-label-result__label-title";
      if (combinedDocument && summaryCount > 1) {
        title.textContent = "All labels";
      } else {
        title.textContent = labels.length === 1 ? "Shipping label" : "Label " + entry.packageNumber;
      }

      const tracking = document.createElement("p");
      tracking.className = "ups-label-result__label-tracking";
      tracking.textContent = trimTrailingPeriod(
        combinedDocument && summaryCount > 1
          ? "Printable file for all " + summaryCount + " labels"
          : "Tracking: " + (entry.trackingNumber || "Pending")
      );

      const actions = document.createElement("div");
      actions.className = "ups-label-result__actions";

      const download = document.createElement("a");
      download.className = "button accent";
      download.href = entry.url;
      download.target = "_blank";
      download.rel = "noopener";
      download.download = entry.fileName || ("ups-label-" + entry.packageNumber);
      if (combinedDocument && summaryCount > 1) {
        download.textContent = "Download all labels";
      } else {
        download.textContent = labels.length === 1 ? "Download label" : "Download label " + entry.packageNumber;
      }

      const printButton = document.createElement("button");
      printButton.type = "button";
      printButton.className = "button outline";
      if (combinedDocument && summaryCount > 1) {
        printButton.textContent = "Print all labels";
      } else {
        printButton.textContent = labels.length === 1 ? "Print label" : "Print label " + entry.packageNumber;
      }
      printButton.addEventListener("click", function () {
        onPrint(entry.url);
      });

      actions.appendChild(download);
      actions.appendChild(printButton);
      card.appendChild(title);
      card.appendChild(tracking);
      card.appendChild(actions);
      listElement.appendChild(card);
    });
  }

  function formatAddressDisplay(address) {
    if (!address) {
      return "";
    }

    var lines = [];

    if (address.address1) {
      lines.push(address.address1);
    }

    if (address.address2) {
      lines.push(address.address2);
    }

    var locality = "";

    if (address.city) {
      locality += address.city;
    }

    if (address.state) {
      locality += (locality ? ", " : "") + address.state;
    }

    if (address.postalCode) {
      locality += (address.state ? " " : (locality ? ", " : "")) + address.postalCode;
    }

    if (locality) {
      lines.push(locality);
    }

    return lines.join("\n");
  }

  function initSection(section) {
    const endpointUrl = (section.dataset.endpointUrl || "").trim();
    const pickupEndpointUrl = derivePickupEndpoint(endpointUrl, (section.dataset.pickupEndpointUrl || "").trim());
    const cancelPickupEndpointUrl = deriveCancelPickupEndpoint(pickupEndpointUrl, (section.dataset.cancelPickupEndpointUrl || "").trim());
    const form = section.querySelector("form.ups-label-form");
    const submitButton = section.querySelector("[data-ups-submit]");
    const status = section.querySelector("[data-ups-status]");
    const addressReview = section.querySelector("[data-ups-address-review]");
    const enteredAddress = section.querySelector("[data-ups-entered-address]");
    const addressCandidates = section.querySelector("[data-ups-address-candidates]");
    const suggestedAddress = section.querySelector("[data-ups-suggested-address]");
    const useSuggestedAddressButton = section.querySelector("[data-ups-use-suggested-address]");
    const result = section.querySelector("[data-ups-result]");
    const resultEyebrow = section.querySelector("[data-ups-result-eyebrow]");
    const resultTitle = section.querySelector("[data-ups-result-title]");
    const labelCount = section.querySelector("[data-ups-label-count]");
    const trackingSummary = section.querySelector("[data-ups-tracking-summary]");
    const trackingList = section.querySelector("[data-ups-tracking-list]");
    const labelList = section.querySelector("[data-ups-label-list]");
    const pickupCard = section.querySelector("[data-ups-pickup-card]");
    const pickupForm = section.querySelector("form.ups-pickup-form");
    const pickupSubmit = section.querySelector("[data-ups-pickup-submit]");
    const pickupStatus = section.querySelector("[data-ups-pickup-status]");
    const pickupResult = section.querySelector("[data-ups-pickup-result]");
    const pickupSummary = section.querySelector("[data-ups-pickup-summary]");
    const pickupPrn = section.querySelector("[data-ups-pickup-prn]");
    const pickupChargeRow = section.querySelector("[data-ups-pickup-charge-row]");
    const pickupCharge = section.querySelector("[data-ups-pickup-charge]");
    const pickupResultEyebrow = section.querySelector("[data-ups-pickup-result-eyebrow]");
    const pickupResultTitle = section.querySelector("[data-ups-pickup-result-title]");
    const cancelPickupButton = section.querySelector("[data-ups-cancel-pickup]");

    if (!form) {
      return;
    }

    let labelUrls = [];
    let activeAbortController = null;
    let activePickupAbortController = null;
    let activeCancelPickupAbortController = null;
    let currentPickupPrn = "";
    let pendingAddressCandidates = [];

    const resetPickup = function () {
      if (pickupCard) {
        pickupCard.hidden = true;
      }

      if (pickupResult) {
        pickupResult.hidden = true;
      }

      if (pickupPrn) {
        pickupPrn.textContent = "";
      }

      currentPickupPrn = "";

      if (pickupCharge) {
        pickupCharge.textContent = "";
      }

      if (pickupChargeRow) {
        pickupChargeRow.hidden = true;
      }

      if (cancelPickupButton) {
        cancelPickupButton.hidden = true;
      }

      if (pickupResultEyebrow) {
        pickupResultEyebrow.textContent = "Pickup scheduled";
      }

      if (pickupResultTitle) {
        pickupResultTitle.textContent = "UPS pickup request confirmed";
      }

      hideStatus(pickupStatus);
    };

    const resetAddressReview = function () {
      pendingAddressCandidates = [];

      if (addressReview) {
        addressReview.hidden = true;
      }

      if (enteredAddress) {
        enteredAddress.textContent = "";
      }

      if (suggestedAddress) {
        suggestedAddress.textContent = "";
      }

      if (addressCandidates) {
        addressCandidates.innerHTML = "";
      }
    };

    const renderAddressReview = function (payload, data) {
      if (!addressReview || !enteredAddress || !suggestedAddress || !addressCandidates) {
        return;
      }

      pendingAddressCandidates = Array.isArray(data && data.candidates) ? data.candidates.slice() : [];

      enteredAddress.textContent = formatAddressDisplay(data && data.enteredAddress ? data.enteredAddress : {
        address1: payload.senderAddress1,
        city: payload.senderCity,
        state: payload.senderState,
        postalCode: payload.senderPostalCode,
        countryCode: "US"
      });

      addressCandidates.innerHTML = "";
      pendingAddressCandidates.forEach(function (candidate, index) {
        var option = document.createElement("option");
        option.value = String(index);
        option.textContent = formatAddressDisplay(candidate).replace(/\n/g, " • ");
        addressCandidates.appendChild(option);
      });

      if (pendingAddressCandidates[0]) {
        addressCandidates.value = "0";
        suggestedAddress.textContent = formatAddressDisplay(pendingAddressCandidates[0]);
      } else {
        suggestedAddress.textContent = "";
      }

      addressReview.hidden = pendingAddressCandidates.length === 0;

      if (!addressReview.hidden) {
        revealSection(addressReview);
      }
    };

    const openPrintWindow = function (url) {
      if (!url) {
        return;
      }

      const printWindow = window.open(url, "_blank", "noopener");

      if (printWindow) {
        printWindow.focus();
      }
    };

    const resetResult = function () {
      result.hidden = true;
      if (resultEyebrow) {
        resultEyebrow.textContent = "Label created";
      }

      if (resultTitle) {
        resultTitle.textContent = "UPS label is ready";
      }

      if (labelCount) {
        labelCount.textContent = "";
      }

      if (labelList) {
        labelList.innerHTML = "";
      }

      if (trackingList) {
        trackingList.innerHTML = "";
      }

      if (trackingSummary) {
        trackingSummary.hidden = true;
      }

      resetPickup();

      revokeLabelUrls(labelUrls);
      labelUrls = [];
    };

    const primePickupForm = function (labelPayload, labelResponse) {
      if (!pickupForm || !pickupCard) {
        return;
      }

      var resolvedOriginAddress = labelResponse && labelResponse.originAddress ? labelResponse.originAddress : {
        address1: labelPayload.senderAddress1 || "",
        address2: "",
        city: labelPayload.senderCity || "",
        state: labelPayload.senderState || "",
        postalCode: labelPayload.senderPostalCode || "",
        countryCode: "US"
      };

      setFieldValue(pickupForm, "officeName", labelPayload.officeName || "");
      setFieldValue(pickupForm, "email", labelPayload.email || "");
      setFieldValue(pickupForm, "senderAddress1", resolvedOriginAddress.address1 || "");
      setFieldValue(pickupForm, "senderAddress2", resolvedOriginAddress.address2 || "");
      setFieldValue(pickupForm, "senderCity", resolvedOriginAddress.city || "");
      setFieldValue(pickupForm, "senderState", resolvedOriginAddress.state || "");
      setFieldValue(pickupForm, "senderPostalCode", resolvedOriginAddress.postalCode || "");
      setFieldValue(pickupForm, "trackingNumber", labelResponse.trackingNumber || "");
      setFieldValue(pickupForm, "labelRequestId", labelResponse.requestId || "");
      setFieldValue(pickupForm, "packageCount", String(labelResponse.packageCount || labelPayload.packageCount || 1));
      setFieldValue(pickupForm, "pickupConfirmationNumber", "");
      setFieldValue(pickupForm, "contactName", labelPayload.contactName || "");
      setFieldValue(pickupForm, "phone", labelPayload.phone || "");

      if (!pickupForm.elements.namedItem("pickupDate").value) {
        setFieldValue(pickupForm, "pickupDate", getNextBusinessDateString(getLocalDateString()));
      }

      if (!pickupForm.elements.namedItem("readyTime").value) {
        setFieldValue(pickupForm, "readyTime", "09:00");
      }

      if (!pickupForm.elements.namedItem("closeTime").value) {
        setFieldValue(pickupForm, "closeTime", "17:00");
      }

      if (!pickupForm.elements.namedItem("pickupPoint").value) {
        setFieldValue(pickupForm, "pickupPoint", "Front desk");
      }

      if (pickupSummary) {
        pickupSummary.textContent =
          (resolvedOriginAddress.address1 || "") +
          ", " +
          (resolvedOriginAddress.city || "") +
          ", " +
          (resolvedOriginAddress.state || "") +
          " " +
          (resolvedOriginAddress.postalCode || "");
      }

      pickupCard.hidden = false;
      applyPickupFieldConstraints(pickupForm);
      syncPickupFieldValidity(pickupForm);
    };

    if (pickupForm) {
      const pickupDateField = pickupForm.elements.namedItem("pickupDate");

      if (pickupDateField && !pickupDateField.value) {
        pickupDateField.value = getNextBusinessDateString(getLocalDateString());
      }

      applyPickupFieldConstraints(pickupForm);
      syncPickupFieldValidity(pickupForm);

      ["pickupDate", "readyTime", "closeTime"].forEach(function (fieldName) {
        var field = pickupForm.elements.namedItem(fieldName);

        if (!field) {
          return;
        }

        field.addEventListener("change", function () {
          syncPickupFieldValidity(pickupForm);
        });

        field.addEventListener("input", function () {
          syncPickupFieldValidity(pickupForm);
        });
      });
    }

    var buildLabelPayload = function (addressDecision) {
      var payload = normalizePayload(new FormData(form));

      if (addressDecision) {
        payload.addressValidationDecision = addressDecision;
      }

      if (addressDecision === "use_suggested" && addressCandidates) {
        var selectedCandidate = pendingAddressCandidates[Number.parseInt(addressCandidates.value || "0", 10)];

        if (selectedCandidate) {
          payload.suggestedAddress1 = selectedCandidate.address1 || "";
          payload.suggestedAddress2 = selectedCandidate.address2 || "";
          payload.suggestedCity = selectedCandidate.city || "";
          payload.suggestedState = selectedCandidate.state || "";
          payload.suggestedPostalCode = selectedCandidate.postalCode || "";
          payload.suggestedCountryCode = selectedCandidate.countryCode || "US";
        }
      }

      return payload;
    };

    var submitLabelRequest = async function (addressDecision) {
      var payload = buildLabelPayload(addressDecision);

      hideStatus(status);
      if (!addressDecision) {
        resetAddressReview();
      }
      resetResult();

      if (!endpointUrl) {
        showStatus(status, "error", "Add the deployed API endpoint URL in the theme section settings first.");
        return;
      }

      if (!form.reportValidity()) {
        showStatus(status, "error", "Please complete all required fields before generating the label.");
        return;
      }

      if (addressDecision === "use_suggested" && !payload.suggestedAddress1) {
        showStatus(status, "error", "The verified address options are no longer available. Please try again.");
        return;
      }

      setButtonBusy(submitButton, true);
      setButtonBusy(useSuggestedAddressButton, true);

      try {
        activeAbortController = new window.AbortController();
        window.setTimeout(function () {
          if (activeAbortController) {
            activeAbortController.abort();
          }
        }, 45000);

        var response = await window.fetch(endpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
          signal: activeAbortController.signal
        });
        var data = await parseResponse(response);

        if (!response.ok) {
          if (data.errorCode === "address_selection_required" && Array.isArray(data.candidates) && data.candidates.length > 0) {
            renderAddressReview(payload, data);
            return;
          }

          throw new Error(withRequestId(data.error || "UPS label generation failed.", data.requestId));
        }

        resetAddressReview();

        const rawLabels = Array.isArray(data.labels) && data.labels.length > 0
          ? data.labels
          : (data.label && data.label.base64
            ? [
                {
                  packageNumber: 1,
                  trackingNumber: data.trackingNumber || "",
                  label: data.label
                }
              ]
            : []);

        if (rawLabels.length === 0) {
          throw new Error("UPS response did not include a printable label.");
        }

        labelUrls = rawLabels.map(function (entry, index) {
          const blob = base64ToBlob(entry.label.base64, entry.label.mimeType);

          return {
            packageNumber: entry.packageNumber || index + 1,
            trackingNumber: entry.trackingNumber || "",
            fileName: entry.label.fileName || ("ups-label-" + (index + 1)),
            url: window.URL.createObjectURL(blob)
          };
        });

        const requestedCount = Number.parseInt(String(data.packageCount || payload.packageCount || rawLabels.length || 1), 10);
        const labelSummaryCount = Number.isInteger(requestedCount) && requestedCount > 0
          ? requestedCount
          : rawLabels.length;
        const trackingNumbers = Array.isArray(data.trackingNumbers)
          ? data.trackingNumbers.filter(Boolean)
          : [];
        const combinedDocument = labelUrls.length === 1 && labelSummaryCount > 1;

        if (resultEyebrow) {
          resultEyebrow.textContent = labelSummaryCount === 1 ? "Label created" : "Labels created";
        }

        if (resultTitle) {
          resultTitle.textContent = labelSummaryCount === 1 ? "UPS label is ready" : "UPS labels are ready";
        }

        if (labelCount) {
          labelCount.textContent = labelSummaryCount === 1
            ? "1 label created"
            : labelSummaryCount + " labels created";
        }

        renderTrackingList(trackingList, trackingSummary, trackingNumbers);
        renderLabelList(labelList, labelUrls, openPrintWindow, {
          summaryCount: labelSummaryCount,
          combinedDocument: combinedDocument
        });
        result.hidden = false;
        revealSection(result);
        primePickupForm(payload, {
          requestId: data.requestId,
          trackingNumber: data.trackingNumber || (labelUrls[0] && labelUrls[0].trackingNumber) || "",
          packageCount: data.packageCount || rawLabels.length,
          originAddress: data.originAddress || null
        });

        showStatus(
          status,
          "success",
          withRequestId(
            data.duplicateRequest
              ? (data.message || "This label request was already processed recently. Showing the latest label details.")
              : (labelSummaryCount === 1
                ? "UPS label generated successfully."
                : "UPS " + labelSummaryCount + " labels generated successfully."),
            data.requestId
          )
        );
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(status, "error", "The request timed out. Please try again.");
        } else {
          showStatus(status, "error", error.message || "Something went wrong while creating the UPS label.");
        }
      } finally {
        activeAbortController = null;
        setButtonBusy(submitButton, false);
        setButtonBusy(useSuggestedAddressButton, false);
      }
    };

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      submitLabelRequest("");
    });

    if (useSuggestedAddressButton) {
      useSuggestedAddressButton.addEventListener("click", function () {
        submitLabelRequest("use_suggested");
      });
    }

    if (addressCandidates) {
      addressCandidates.addEventListener("change", function () {
        var selectedCandidate = pendingAddressCandidates[Number.parseInt(addressCandidates.value || "0", 10)];
        suggestedAddress.textContent = selectedCandidate ? formatAddressDisplay(selectedCandidate) : "";
      });
    }

    form.addEventListener("input", function () {
      if (pendingAddressCandidates.length > 0) {
        resetAddressReview();
      }
    });

    form.addEventListener("change", function () {
      if (pendingAddressCandidates.length > 0) {
        resetAddressReview();
      }
    });

    if (!pickupForm || !pickupSubmit) {
      return;
    }

    pickupForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      hideStatus(pickupStatus);

      if (pickupResult) {
        pickupResult.hidden = true;
      }

      if (pickupChargeRow) {
        pickupChargeRow.hidden = true;
      }

      if (!pickupEndpointUrl) {
        showStatus(pickupStatus, "error", "Pickup endpoint is not configured yet.");
        return;
      }

      if (!pickupForm.reportValidity()) {
        showStatus(pickupStatus, "error", "Please complete all required pickup fields first.");
        return;
      }

      var pickupGuardrailError = syncPickupFieldValidity(pickupForm);

      if (pickupGuardrailError) {
        showStatus(pickupStatus, "error", pickupGuardrailError.message);
        if (pickupGuardrailError.field && typeof pickupGuardrailError.field.reportValidity === "function") {
          pickupGuardrailError.field.reportValidity();
        }
        return;
      }

      setButtonBusy(pickupSubmit, true);

      try {
        activePickupAbortController = new window.AbortController();
        window.setTimeout(function () {
          if (activePickupAbortController) {
            activePickupAbortController.abort();
          }
        }, 45000);

        const payload = normalizePickupPayload(new FormData(pickupForm));
        const response = await window.fetch(pickupEndpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
          signal: activePickupAbortController.signal
        });
        const data = await parseResponse(response);

        if (!response.ok) {
          throw new Error(withRequestId(data.error || "UPS pickup scheduling failed.", data.requestId));
        }

        currentPickupPrn = data.pickupConfirmationNumber || "";
        setFieldValue(pickupForm, "pickupConfirmationNumber", currentPickupPrn);
        pickupPrn.textContent = currentPickupPrn || "Pending";

        if (data.chargeTotal && pickupCharge && pickupChargeRow) {
          pickupCharge.textContent = (data.chargeCurrency ? data.chargeCurrency + " " : "") + data.chargeTotal;
          pickupChargeRow.hidden = false;
        }

        if (cancelPickupButton) {
          cancelPickupButton.hidden = !currentPickupPrn;
        }

        if (pickupResultEyebrow) {
          pickupResultEyebrow.textContent = "Pickup scheduled";
        }

        if (pickupResultTitle) {
          pickupResultTitle.textContent = "UPS pickup request confirmed";
        }

        pickupResult.hidden = false;
        revealSection(pickupResult);
        showStatus(
          pickupStatus,
          "success",
          withRequestId(
            data.duplicateRequest
              ? (data.message || "This pickup request was already processed recently. Showing the latest pickup details.")
              : (data.message || "UPS pickup scheduled successfully."),
            data.requestId
          )
        );
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(pickupStatus, "error", "The pickup request timed out. Please try again.");
        } else {
          showStatus(pickupStatus, "error", error.message || "Something went wrong while scheduling the UPS pickup.");
        }
      } finally {
        activePickupAbortController = null;
        setButtonBusy(pickupSubmit, false);
      }
    });

    if (!cancelPickupButton) {
      return;
    }

    cancelPickupButton.addEventListener("click", async function () {
      hideStatus(pickupStatus);

      if (!cancelPickupEndpointUrl) {
        showStatus(pickupStatus, "error", "Cancel pickup endpoint is not configured yet.");
        return;
      }

      if (!currentPickupPrn) {
        showStatus(pickupStatus, "error", "Pickup confirmation number is missing.");
        return;
      }

      setButtonBusy(cancelPickupButton, true);

      try {
        activeCancelPickupAbortController = new window.AbortController();
        window.setTimeout(function () {
          if (activeCancelPickupAbortController) {
            activeCancelPickupAbortController.abort();
          }
        }, 45000);

        const response = await window.fetch(cancelPickupEndpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            pickupConfirmationNumber: currentPickupPrn,
            trackingNumber: pickupForm.elements.namedItem("trackingNumber").value || "",
            officeName: pickupForm.elements.namedItem("officeName").value || "",
            contactName: pickupForm.elements.namedItem("contactName").value || "",
            email: pickupForm.elements.namedItem("email").value || "",
            phone: pickupForm.elements.namedItem("phone").value || "",
            senderAddress1: pickupForm.elements.namedItem("senderAddress1").value || "",
            senderAddress2: pickupForm.elements.namedItem("senderAddress2").value || "",
            senderCity: pickupForm.elements.namedItem("senderCity").value || "",
            senderState: pickupForm.elements.namedItem("senderState").value || "",
            senderPostalCode: pickupForm.elements.namedItem("senderPostalCode").value || "",
            website: pickupForm.elements.namedItem("website").value || ""
          }),
          signal: activeCancelPickupAbortController.signal
        });
        const data = await parseResponse(response);

        if (!response.ok) {
          throw new Error(withRequestId(data.error || "UPS pickup cancel failed.", data.requestId));
        }

        if (pickupResultEyebrow) {
          pickupResultEyebrow.textContent = "Pickup cancelled";
        }

        if (pickupResultTitle) {
          pickupResultTitle.textContent = "UPS pickup request cancelled";
        }

        cancelPickupButton.hidden = true;
        showStatus(
          pickupStatus,
          "success",
          withRequestId(
            data.duplicateRequest
              ? (data.message || "This pickup cancellation was already processed recently.")
              : (data.message || "UPS pickup cancelled successfully."),
            data.requestId
          )
        );
      } catch (error) {
        if (error.name === "AbortError") {
          showStatus(pickupStatus, "error", "The cancel request timed out. Please try again.");
        } else {
          showStatus(pickupStatus, "error", error.message || "Something went wrong while cancelling the UPS pickup.");
        }
      } finally {
        activeCancelPickupAbortController = null;
        setButtonBusy(cancelPickupButton, false);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-ups-label-form]").forEach(initSection);
  });
})();
